import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Box, IconButton, Tooltip } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import DashboardIcon from "@mui/icons-material/Dashboard";
import AssessmentIcon from "@mui/icons-material/Assessment";

const NavToolbar = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();

  // Navigation items with icon and route
  const navItems = [
    {
      label: "Sync Dashboard",
      icon: DashboardIcon,
      route: "/syncdashboard",
    },
    {
      label: "Survey Metrics",
      icon: AssessmentIcon,
      route: "/surveymetrics",
    },
  ];

  const handleNavigation = (route) => {
    if (location.pathname !== route) {
      navigate(route);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        gap: 0.5,
        alignItems: "center",
      }}
    >
      {navItems.map((item) => {
        const Icon = item.icon;
        const isActive = location.pathname === item.route;

        return (
          <Tooltip
            key={item.route}
            title={item.label}
            arrow
          >
            <IconButton
              size="small"
              onClick={() => handleNavigation(item.route)}
              sx={{
                color: "black",
                backgroundColor: isActive
                  ? "rgba(255, 255, 255, 0.2)"
                  : "transparent",
                "&:hover": {
                  backgroundColor: "rgba(255, 255, 255, 0.3)",
                },
                transition: "background-color 0.3s ease",
              }}
            >
              <Icon />
            </IconButton>
          </Tooltip>
        );
      })}
    </Box>
  );
};

export default NavToolbar;
